
 import React, {Component} from 'react';
 import EditorInformation from "../../components/EditorInformation";
 import {Row} from "antd";
 
 export class EditorInformationOfWebEditor extends EditorInformation {
     renderEditorInformation = () => {
         return (
             <></>
         )
     };
 }